/** Drop feature strings that already repeat seat/connection limits. */
export const uniquePlanFeatures = (plan, limit = 4) => {
  const features = Array.isArray(plan?.features) ? plan.features : [];
  return features
    .filter((feature) => {
      const s = String(feature || '').toLowerCase();
      if (!s) return false;
      if (/\b\d+\+?\s*users?\b/.test(s) || /\bunlimited users\b/.test(s)) return false;
      if (/\b\d+\+?\s*connections?\b/.test(s) || /\bunlimited connections\b/.test(s)) return false;
      return true;
    })
    .slice(0, limit);
};
